export default "__VITE_ASSET__D1fU0Rea__"